const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#0193d7',
                hover: '#0073a8'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
